import {Box, Link} from '@material-ui/core'
import {FunctionComponent, ReactElement} from 'react'
import {ReactComponent as Android} from './assets/download_android.svg'
import {ReactComponent as Apple} from './assets/download_apple.svg'
import {ReactComponent as Windows} from './assets/download_windows.svg'
import {IconsContainer} from './styles'
import {
  ANDROID_MT5_DOWNLOAD_LINK,
  APPLE_MT5_DOWNLOAD_LINK,
  WINDOWS_MT5_DOWNLOAD_LINK,
} from './constants'

type LogoPropsLink = {
  icon: FunctionComponent<React.SVGProps<SVGSVGElement>>
  href: string
}

export function MTPlatform() {
  return (
    <IconsContainer>
      <LogoLink href={WINDOWS_MT5_DOWNLOAD_LINK} icon={Windows} />
      <LogoLink href={APPLE_MT5_DOWNLOAD_LINK} icon={Apple} />
      <LogoLink href={ANDROID_MT5_DOWNLOAD_LINK} icon={Android} />
    </IconsContainer>
  )
}

const LogoLink = ({href, icon}: LogoPropsLink): ReactElement => (
  <Link href={href}>
    <Box component={icon} />
  </Link>
)
